import axios from 'axios'
import store from '@/store'

let infoHandler = (response) => {
  // console.log(response)
  let request = {
    headers: response.config.headers,
    method: response.config.method,
    url: response.config.url,
    body: (response.config.data === undefined) ? 'None' : JSON.parse(response.config.data) // pars if there's a body
  }
  let info = response.data.info
  /* info[key].kind designates the way the info is handled
  ** notification - shown on top bar, uses severity to determine color
  ** alert - shown in a modal
  ** validation - Used to display info under form fields
  ** debug - same as alert except only visible to admins/developers
  */
  let debugMode = store.getters['person/primaryPerson'] && store.getters['person/settings'].developmentDebugMode === '1'

  Object.entries(info).forEach(([key, entry]) => { // loop through entries
    entry.request = request // append debugging info
    if (entry.category === 'authenticationFailed') {
      store.commit('logout', null, { root: true })
    }
    // if user is a developer
    if (debugMode) {
      store.commit('info/newAlert', entry, { root: true })
    }
    switch (entry.kind) {
      case 'notification':
        store.commit('info/newNotification', entry, { root: true })
        break
      case 'validation':
        store.commit('info/newNotification', entry, { root: true })
        break
      case 'alert': // falls-through to next case
      case 'debug':
      default:
        // handle everything else as an alert modal
        if (!debugMode) { // we already made an alert if it's in debug mode
          store.commit('info/newAlert', entry, { root: true })
        }
    }
  })
}
let unparsableHandler = (response) => {
  // uncaught error. lets generate what we can
  let entry = {
    title: 'Unparseable Error.',
    message: 'An error occurred that cannot be interpretted.',
    details: response.data,
    request: response.config
  }
  store.dispatch('info/newAlert', entry, { root: true })
}

// interceptor
axios.interceptors.response.use((response) => {
  // handle the response info
  if (response.data.info) {
    infoHandler(response)
  } else {
    unparsableHandler(response)
  }
  return response
}, (error) => {
  console.trace() // backtrace for debugging
  let info = error
  if (!error?.response?.status) {
    return axios.request(error.config)
  } else if (error?.response?.data?.info) {
    // infoHandler(error.request, error.response.data.info)
    infoHandler(error.response)
  } else {
    unparsableHandler(error.response)
  }
  return Promise.reject(info)
})
